module.exports = __webpack_public_path__ + "static/dashboard_intro2@2x-a88689b908b08ed2bf4c76cfd3304129.png";